import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {useApolloClient} from '@apollo/client';

import { 
  fetchOneDomainInstance,
  OperationTargets
} from '../../api/CommonCrudOperations'

import LTRDomainObjectInfo from '../shared/domains/LTRDomainObjectInfo';

// Our labels in the Info Table
const labels = {
  type: "TYPE",
  institution: "INSTITUTION",
  accountNumber: "ACCOUNT NUMBER",
  billType: "TYPE OF BILL",
  billingFrequency: "BILL FREQUENCY",
  howPaid: "HOW PAID",
  notes: "NOTES"
}

export const prepareTableRowInfo = (liability) => {
  // prepare table data for show
  let messageAction = '';
  let messageDoc = '';
  if (liability.actionItems) {
    messageAction = liability.actionItems.length === 0 ? "This liability has NO action items" :
    "This liability has " + liability.actionItems.length + " action items";
  }
  if (liability.LiabilityAttachments) {
    messageDoc = liability.attachments.length === 0 ? "This liability has NO attached files":
    "This liability has " + liability.attachments.length + " attached files"
  }
  const tableInfo = {
    name: liability.name,
    actionItemMessage: messageAction,
    documentsMessage: messageDoc,
    fieldData : [
      {
        field: labels.type,
        value: liability.type
      },
      {
        field: labels.institution,
        value: liability.institution
      },
      {
        field: labels.accountNumber,
        value: liability.accountNumber
      }
    ]
  }

  let billerData;
  if (liability.billers && liability.billers.length > 0) {
    const biller = liability.billers[0];   
    billerData = [
      {
        field: labels.billType,
        value: biller.billType
      },
      {
        field: labels.howPaid,
        value: biller.howPaid
      },
      {
        field: labels.billingFrequency,
        value: biller.billingFrequency
      },  
    ] 
  } else {
    billerData = billerData = [
      {
        field: labels.billType,
        value: ''
      },
      {
        field: labels.howPaid,
        value: ''
      },
      {
        field: labels.billingFrequency,
        value: ''
      },  
    ]
  }
  // add the biller data
  tableInfo.fieldData = tableInfo.fieldData.concat(billerData);
      
  // finally, notes
  const notesData = {
    field: labels.notes,
    value: liability.usage
  }  
  tableInfo.fieldData.push(notesData);

  return tableInfo;  
}

const useLiabilityFetch = (client, domainId, updateFn) => {
  const [liability, setLiability] = useState(null);
  
  useEffect(() => {
    const fetchLiability = () => { 
      fetchOneDomainInstance(client, OperationTargets.Liabilities, domainId)
      .then(result => { 
        const liability = result.item;
        setLiability(liability);
        updateFn(liability);
      })
      .catch(error => {
        console.log(error) 
      });
    }

    if (liability === null && domainId !== null) {
      fetchLiability()
    }  
  }, [client, updateFn]);
};

const LiabilityInfo = (props) => {
  const client = useApolloClient();

  const [showInfoDialogOpen, setShowInfoDialogOpen] = useState(false);
  const [tableInfo, setTableInfo] = useState(null);
  const [liability, setLiability] = useState(null);

  const handleShowInfoClose = () => {
    setShowInfoDialogOpen(false);
    // notify the client
    props.handleClose();
  }

  useLiabilityFetch(client, props.domainId, (fetchedData) => {
    if (fetchedData !== null) {
      setLiability(fetchedData);
      const info = prepareTableRowInfo(fetchedData);
      setTableInfo(info);
      setShowInfoDialogOpen(true);
    }
  });

  if (tableInfo === null) {
    return null;
  }

  return (
    <React.Fragment>  
      {showInfoDialogOpen ? (
        <LTRDomainObjectInfo
          open = {props.open}
          title = {liability.name}
          tableData = {tableInfo}
          handleClose = {handleShowInfoClose}
        />): null
      }
    </React.Fragment>
  )
}

LiabilityInfo.propTypes = {
  open: PropTypes.bool.isRequired,
  domainId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
}

export default (LiabilityInfo);
